import { Component, EventEmitter, Input, Output } from '@angular/core';
import { COOKIE_STATUS } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'terms-and-conditions-list-view',
  templateUrl: './terms-and-conditions-list-view.component.html',
  styleUrl: './terms-and-conditions-list-view.component.scss',
  standalone: false,
})
export class TermsAndConditionsListViewComponent {
  @Input() cookies: app.models.CookieModel[];
  @Input() props: app.models.DynamicPropsDictionary;
  @Output() deleteCookieEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() editCookieEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() redirectCookieConsentEvent: EventEmitter<string> = new EventEmitter<string>();

  public cookieStatus = COOKIE_STATUS;

  isPastStartDate(startDate: Date): boolean {
    const today = new Date();
    const dateToCheck = new Date(startDate);
    return dateToCheck < today;
  }

  isPastExpiryDate(expiryDate: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateToCheck = new Date(expiryDate);
    return dateToCheck >= today;
  }

  public deleteCookie(cookieId: string) {
    this.deleteCookieEvent.emit(cookieId);
  }

  public editCookie(cookieId: string) {
    this.editCookieEvent.emit(cookieId);
  }

  public redirectCookieConsent(cookieId: string) {
    this.redirectCookieConsentEvent.emit(cookieId);
  }
}
